/**
 * 交班事项富文本
 */
import React, { useContext, useEffect, useRef } from 'react';
import { message } from 'antd';
import { createEditor, createToolbar, i18nChangeLanguage } from '@wangeditor/editor';
import '@wangeditor/editor/dist/css/style.css';
import { uploadFile } from '@wywk/utils';
import intl from 'react-intl-universal';

import { DrawerContext } from '@/pages/handover/helper';

import styles from './index.module.scss';

interface IProps {
  defaultValue: string;
  onChange: (val: string) => void;
}

const Index: React.FC<IProps> = (props) => {
  const toolNodeRef = useRef<HTMLDivElement>();
  const editorNodeRef = useRef<HTMLDivElement>();
  const editorRef = useRef<ReturnType<typeof createEditor>>(null);
  const { setLoadingStatus } = useContext(DrawerContext);

  const customUploadImage = async (file, callback) => {
    try {
      setLoadingStatus(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('source', 'ypms');
      const res = await uploadFile(formData);
      if (res && res.data && res.data.url) {
        setLoadingStatus(false);
        callback(res.data.url, '', res.data.url);
        return true;
      }
    } catch (e) {
      //
    }
    setLoadingStatus(false);
    message.error(intl.get('handover_richtext_error_image_upload_fail'));
    return false;
  };

  const initEditor = () => {
    i18nChangeLanguage(intl.get('handover_richtext_i18n_name'));
    const editor = createEditor({
      selector: editorNodeRef.current,
      html: props.defaultValue || '',
      config: {
        placeholder: intl.get('handover_richtext_placeholder'),
        scroll: true,
        onChange: (event) => {
          const operations = event.operations || [];
          // 只是选中时 不触发change 防止接口频繁调用
          if (operations.length === 1 && operations[0].type === 'set_selection') return;
          props.onChange(editor.getHtml());
        },
        MENU_CONF: {
          uploadImage: { customUpload: customUploadImage },
        },
      },
      mode: 'default',
    });
    editorRef.current = editor;
  };

  const initToolBar = () => {
    createToolbar({
      editor: editorRef.current,
      selector: toolNodeRef.current,
      config: {
        insertKeys: {
          index: 20,
          keys: ['uploadImage'],
        },
        excludeKeys: ['insertLink', 'group-image', 'group-video', 'fullScreen'],
      },
      mode: 'default',
    });
  };

  useEffect(() => {
    initEditor();
    initToolBar();
    return () => {
      if (editorRef.current) {
        editorRef.current.destroy();
      }
    };
  }, []);

  return (
    <div className={styles.richTextWrapper}>
      <div ref={toolNodeRef} className={styles.toolbarNode} />
      <div ref={editorNodeRef} className={styles.editorNode} />
    </div>
  );
};

export default Index;
